import { atom } from 'recoil';

import PricingStore from 'src/app_deprecated/stores/PricingStore';

type PricingAtom = {
  lspChargeCodes: any[];
};

export const pricingAtom = atom<PricingAtom>({
  key: 'pricing',
  default: {
    lspChargeCodes: [],
  } as PricingAtom,
  effects_UNSTABLE: [useSyncStateEffect],
});

function useSyncStateEffect({ setSelf, trigger }) {
  function changeListener() {
    const { lspChargeCodes } = PricingStore;

    setSelf({ lspChargeCodes });
  }

  if (trigger === 'get') {
    changeListener(); // initial call
  }

  PricingStore.addChangeListener(changeListener);

  return () => PricingStore.removeChangeListener(changeListener);
}
